import axios from "axios";
import { similarFlightApiPrefix } from "../paths";
import {
  GetSimilarFlightsRequest,
  GetSimilarFlightsResponse,
  IApiConfig,
  NETWORK_CALL_FAILED,
} from "@hopper-b2b/types";
import { trackEvent } from "@hopper-b2b/api";

const getSimilarFlightsPath = `${similarFlightApiPrefix}/list`;

export const getSimilarFlights = (
  body: GetSimilarFlightsRequest,
  apiConfig?: IApiConfig
): Promise<GetSimilarFlightsResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.post(getSimilarFlightsPath, body);

      resolve(res.data);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });

export default getSimilarFlights;
